if (!customElements.get('product-variants')) {
  class ProductVariants extends HTMLElement {
    constructor() {
      super();

      this.form = this.closest('form');
      this.product = this.closest('.js-product');
      this.productMedia = this.product.querySelector('product-media');
      this.price = this.product.querySelector('.js-price');
      this.priceMsg = this.product.querySelector('.js-price-msg');
      this.btnAdd = this.form.querySelector('[name="add"]');
      this.variantsSelect = this.querySelector('select[name="id"]');
      this.colorCurrentValues = this.querySelectorAll('.js-current-value');
      this.optionsArray = Array.from(this.variantsSelect.options);

      this.setVisibleMediaIds();

      this.addEventListener('input', (e) => {
        if (e.target.hasAttribute('data-group-color')) {
          const groupCheckboxes = this.querySelectorAll(
            '.js-color-group-options input',
          );

          groupCheckboxes.forEach((groupCheckbox) => {
            if (groupCheckbox !== e.target) {
              groupCheckbox.checked = false;
            }
          });

          const similarCheckboxes = this.querySelectorAll(
            '.js-similar-option input',
          );
          const similarColorsCountContainer = this.querySelector(
            '.js-similar-option [data-similar-colors-count]',
          );
          let similarColorsCount = 0;

          similarCheckboxes.forEach((similarChecbox) => {
            const parent = similarChecbox.parentNode;

            parent.classList.toggle(
              'hidden',
              parent.dataset.groupColor !== e.target.dataset.groupColor,
            );

            if (parent.dataset.groupColor === e.target.dataset.groupColor) {
              similarColorsCount++;
            }
          });

          if (similarColorsCountContainer) {
            similarColorsCountContainer.textContent = similarColorsCount;
          }

          const targetSimilarCheckbox = this.querySelector(
            `.js-similar-option [data-group-color="${e.target.dataset.groupColor}"] input`,
          );

          if (targetSimilarCheckbox) {
            targetSimilarCheckbox.checked = true;

            targetSimilarCheckbox.dispatchEvent(
              new Event('input', { bubbles: true }),
            );
          }

          const targetSimilarCheckboxes = this.querySelectorAll(
            `.js-similar-option [data-group-color="${e.target.dataset.groupColor}"] input`,
          );

          this.querySelector('.js-similar-option').classList.toggle(
            'hidden',
            targetSimilarCheckboxes.length === 1,
          );
        }

        if (e.target.hasAttribute('data-similar-color')) {
          const targetColor = e.target.dataset.similarColor;
          const targetColorGroup = e.target.parentNode.dataset.groupColor;
          const targetInput = this.querySelector(
            `.js-option [data-color="${targetColor}"]`,
          );

          if (targetInput) {
            targetInput.parentNode.classList.remove('hidden');

            targetInput.checked = true;

            targetInput.dispatchEvent(new Event('input', { bubbles: true }));
          }
        }

        const checkedOptions = Array.from(
          this.querySelectorAll('.js-option input:checked'),
        );

        let checkedValues = checkedOptions.reduce((acc, checkedOption) => {
          return (acc += `${checkedOption.value},`);
        }, '');
        checkedValues = checkedValues.slice(0, checkedValues.length - 1);

        const newSelectedOption = this.optionsArray.find((option) => {
          return option.dataset.options === checkedValues;
        });

        if (!newSelectedOption) return;

        newSelectedOption.selected = true;

        this.updateHistory();

        if (e.target.hasAttribute('data-color')) {
          this.updateMedia(e.target);

          if (this.hasAttribute('data-dealer-product')) {
            this.querySelectorAll('.js-option input').forEach((input) => {
              if (input !== e.target) input.parentNode.classList.add('hidden');
            });
          }

          this.colorCurrentValues.forEach((colorCurrentValue) => {
            colorCurrentValue.classList.add('hidden');
          });

          const currentValue = e.target
            .closest('.js-option')
            .querySelector('.js-current-value');

          currentValue.textContent = e.target.value;
          currentValue.classList.remove('hidden');
        }

        this.price.innerHTML = newSelectedOption.dataset.price;
        if (this.priceMsg) {
          this.priceMsg.textContent = newSelectedOption.dataset.priceMsg;
        }

        if (!this.btnAdd) return;

        if (newSelectedOption.disabled) {
          this.btnAdd.textContent = this.btnAdd.dataset.soldOutText;
          this.btnAdd.setAttribute('disabled', 'disabled');

          return;
        }

        this.btnAdd.textContent = this.btnAdd.dataset.availableText;
        this.btnAdd.removeAttribute('disabled');
      });
    }

    updateMedia(target) {
      if (!this.productMedia) return;

      const matchingSlide = this.productMedia.slidesArray.find((slide) => {
        return (
          slide.dataset.mediaType === 'image' &&
          slide.dataset.mediaAlt.includes(target.dataset.color)
        );
      });

      this.productMedia.slidesArray.forEach((slide) => {
        if (!matchingSlide) {
          slide.classList.remove('no-js');

          return;
        }

        const matchesColor =
          slide.dataset.mediaType === 'image' &&
          slide.dataset.mediaAlt.includes(target.dataset.color);

        slide.classList.toggle('no-js', !matchesColor);
      });

      const visibleSlides = this.getVisibleSlides();
      const visibleMediaIdArray = visibleSlides.map((slide) => {
        return slide.dataset.mediaId;
      });
      const visibleMediaId = visibleMediaIdArray.join(',');

      if (this.visibleMediaId === visibleMediaId) return;

      this.visibleMediaId = visibleMediaId;

      this.productMedia.counterTotal.textContent =
        visibleSlides.length >= 10
          ? visibleSlides.length
          : `0${visibleSlides.length}`;

      this.productMedia.slider.update();
      this.productMedia.slider.slideTo(0, 0);
    }

    setVisibleMediaIds() {
      if (!this.productMedia) return;

      const visibleSlides = this.getVisibleSlides();
      const visibleMediaIdArray = visibleSlides.map((slide) => {
        return slide.dataset.mediaId;
      });

      this.visibleMediaId = visibleMediaIdArray.join(',');
    }

    getVisibleSlides() {
      const visibleSlides = this.productMedia.slidesArray.filter((slide) => {
        return !slide.classList.contains('no-js');
      });

      return visibleSlides;
    }

    updateHistory() {
      const updatedURL = new URL(window.location.href);

      updatedURL.searchParams.set('variant', this.variantsSelect.value);
      window.history.replaceState({}, '', updatedURL);
    }
  }

  customElements.define('product-variants', ProductVariants);
}
